<template>
    <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.email">

        <div class="text-right leading-tight hidden sm:block">
            <p class="font-semibold" v-if="activeUserInfo.email">{{ activeUserInfo.company }}</p>
            <small>Aktywne do: {{ format_date(activeUserInfo.active_to) }}</small>

        </div>

        <div class="con-img ml-3">
            <router-link to="/moje-konto">
<!--                <img v-if="activeUserInfo.photoURL" key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img"
                     width="40" height="40" class="rounded-full shadow-md cursor-pointer block"/>-->
            </router-link>
        </div>

    </div>
</template>

<script>
import moment from 'moment'

export default {
    computed: {
        activeUserInfo() {
            return this.$store.state.AppActiveUser
        }
    },
    methods: {
        format_date(value) {
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD')
            }
        },
        logout() {
            localStorage.removeItem('userInfo')

            // This is just for demo Purpose. If user clicks on logout -> redirect
            this.$router.push('/pages/login').catch(() => {
            })
        }
    }
}
</script>
